export default __webpack_public_path__ + "static/media/3031 spice rack A top.1c0889a1.png";